import { render, staticRenderFns } from "./engineering_institute.vue?vue&type=template&id=35cd0825&"
import script from "./engineering_institute.vue?vue&type=script&lang=js&"
export * from "./engineering_institute.vue?vue&type=script&lang=js&"
import style0 from "./engineering_institute.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports